'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'انتخاب زمان'
};

exports['default'] = locale;